import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/magicui/blur-fade-text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/magicui/blur-fade.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RippleButton"] */ "/vercel/path0/src/components/magicui/ripple-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResumeCard"] */ "/vercel/path0/src/components/resume-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/vercel/path0/src/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/LightRays.tsx");
